import React from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  makeStyles,
  Typography,
  useMediaQuery
} from '@material-ui/core';
import ReportProblemIcon from '@material-ui/icons/ReportProblem';
import './WarningModal.css';

const WarningModal = ({ toggleWarning, text }) => {
  const matches = useMediaQuery('(min-width:520px)');

  const useStyles = makeStyles({
    body: {
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      padding: '20px',
      height: '100%'
    },

    warning: {
      display: 'flex',
      flexDirection: matches ? 'row' : 'column',
      alignItems: 'center',
      marginBottom: '20px',
      justifyContent: 'center'
    },

    text: {
      textAlign: 'center',
      fontSize: '15px',
      fontWeight: 500,
      marginLeft: matches ? '7px' : '0',
      marginTop: matches ? '0' : '7px'
    },
  });

  const classes = useStyles();

  return (
    <div className="WarningModal">
      <div
        className="pane"
        onClick={() => {
          toggleWarning();
        }}
      />
      <div className="content">
        <div className={classes.body}>
          <div className={classes.warning}>
            <ReportProblemIcon color="primary" fontSize="large" />
            <Typography
              className={classes.text}
              variant="body2"
            >
              {text}
            </Typography>
          </div>
          <Button
            color="primary"
            variant="contained"
            onClick={() => {
              toggleWarning();
            }}
          >
            Aceptar
          </Button>
        </div>
      </div>
    </div>
  );
};

WarningModal.propTypes = {
  toggleWarning: PropTypes.func,
  text: PropTypes.string
};

export default WarningModal;
